import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../components/Header";
import PlanetsBackground from "../components/PlanetsBackground";
import Character from "../components/Character";
import '../styles/Login.css';

export default function TherapistLogin() {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        // Password semplice come richiesto per accesso "nascosto"
        if (password === 'mars2026') {
            localStorage.setItem('isTherapist', 'true');
            navigate('/therapist/dashboard');
        } else {
            setError('Password errata');
        }
    };

    return (
        <div className="login-wrapper">
            <Header />
            <div className="planet-background">
                <PlanetsBackground />
                <div className="login-form-container">
                    <h2 style={{ fontFamily: "'Autour One', cursive", color: 'white', marginBottom: '20px' }}>Area Sviluppatore</h2>
                    <form onSubmit={handleSubmit}>
                        <input
                            type="password"
                            placeholder="Password di accesso"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="login-input"
                        />
                        <button type="submit" className="login-button">Accedi</button>
                        {error && <p className="login-error">{error}</p>}
                    </form>
                </div>
            </div>
            <Character name="Mars" position="left"/>
        </div>
    );
}
